module.exports = __webpack_public_path__ + "media/slide2/contractMediaSlide2Part4vs-a36f2d58.png";